import React from "react";
import { InputNumber, InputNumberProps, Tooltip } from "../utils/local-antd";
import { Flex } from "./Flex";
import { AtiraIcon } from "./AtiraIcon";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { Alignment, LabelDirection } from "./shared/types/SharedLabelProps";
import styled, { useTheme } from "styled-components";
import { FontSize, Text } from "./Text";
import { useTranslation } from "react-i18next";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { ThemeType } from "../theme/Theme";

const StyledInfo = styled(Tooltip)`
  cursor: help;
`;

const OptionalSpan = styled.span`
  color: ${({ theme }) => theme.darkerSub};
  font-size: ${FontSize.s};
`;

type Props = {
  info?: string;
  infoColor?: keyof ThemeType;
  titleColor?: keyof ThemeType;
  labelDirection?: LabelDirection;
  titleAlign?: keyof typeof Alignment;
  labelTooltip?: string;
} & InputNumberProps;

export const InputWithDigitsArrows: React.FC<Props> = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Flex
      width={"100%"}
      gap="s"
      flexDirection={
        props.labelDirection === LabelDirection.HORIZONTAL ? "row" : "column"
      }
      className="atira-input-wrapper"
    >
      {props.title ? (
        <Flex alignItems="center" justifyContent="flex-start" gap="s">
          {props?.info ? (
            <StyledInfo title={props.info}>
              <span>
                <AtiraIcon
                  icon={faInfoCircle}
                  color={props.infoColor || "main"}
                  size="sm"
                />
              </span>
            </StyledInfo>
          ) : null}

          <label
            htmlFor={props.id}
            style={{
              color: theme[props.titleColor || "black"],
              cursor: props?.id ? "pointer" : "auto",
              textAlign: props.titleAlign,
              width: "fit-content",
              fontSize: FontSize.m,
              alignSelf: props.titleAlign || "flex-start",
              flex: props.labelTooltip ? "none" : 1,
              margin:
                props.labelDirection === LabelDirection.HORIZONTAL
                  ? "auto"
                  : "0",
            }}
          >
            {props.title}
            {props.required ? (
              <span style={{ color: theme.danger }}> *</span>
            ) : (
              <OptionalSpan> ({t("common.optional")})</OptionalSpan>
            )}
          </label>
          {props.labelTooltip ? (
            <Tooltip title={props.labelTooltip}>
              <span>
                <AtiraIcon icon={faExclamationCircle} color="lightMain" />
              </span>
            </Tooltip>
          ) : null}
          {props.maxLength || props.minLength ? (
            <Text fontSize="xs" color="darkerSub">
              ({props.minLength ? `${props.minLength} - ` : null}
              {props.maxLength} {t("common.characters")})
            </Text>
          ) : null}
        </Flex>
      ) : null}
      <InputNumber
        {...props}
        onKeyDown={(e) => {
          e.preventDefault();
        }}
      />
    </Flex>
  );
};
